import { gql } from '@apollo/client'

const ALL_CATEGORIES_EN = gql`
  query CategoriesQuery {
    categories_EN_LA {
      _id
      data {
        id
        category {
          id
          name
          filterCategories {
            filterCategoryId
          }
        }
      }
    }
  }
`

const ALL_CATEGORIES_ES = gql`
  query CategoriesQuery {
    categories_ES_LA {
      _id
      data {
        id
        category {
          id
          name
          filterCategories {
            filterCategoryId
          }
        }
      }
    }
  }
`

const ALL_CATEGORIES = {
  EN: ALL_CATEGORIES_EN,
  ES: ALL_CATEGORIES_ES,
}

export { ALL_CATEGORIES }
